import { Mtds } from 'prove-common'
import type { DelegationLevelItem } from './useDelegationLevel'
import { DelegationCardProgress } from './DelegationCardProgress'
import { QuantityStepper } from '../quantity-stepper/QuantityStepper'

type DelegationLeafCardProps = {
  item: DelegationLevelItem
  typeLabel: string
  /** Antall prøver som ennå ikke er fordelt på oppgaven. */
  remainder: number
  canEdit: boolean
  hideControls?: boolean
  isMutating?: boolean
  onChange: (quantity: number) => void
}

/**
 * Kort for nederste nivå, der antall prøver faktisk settes.
 */
export const DelegationLeafCard = ({
  item,
  typeLabel,
  remainder,
  canEdit,
  hideControls = false,
  isMutating = false,
  onChange
}: Readonly<DelegationLeafCardProps>) => {
  return (
    <Mtds.Card className='h-full min-h-72'>
      <Mtds.Grid data-gap={3} className='h-full grid-rows-[auto_1fr_auto]'>
        <Mtds.Grid data-gap={0}>
          <Mtds.Muted>{typeLabel}</Mtds.Muted>
          <Mtds.Heading as='h3' data-size='xs'>
            {item.name}
          </Mtds.Heading>
          {item.isOrphan && (
            <Mtds.Muted>Ligger utenfor organisasjonsstrukturen</Mtds.Muted>
          )}
        </Mtds.Grid>
        {hideControls ? (
          <Mtds.Muted>
            Fordelingen er stoppet på et overordnet nivå og kan derfor ikke
            endres her.
          </Mtds.Muted>
        ) : (
          <Mtds.Grid data-gap={3} data-align-content='end'>
            <QuantityStepper
              label={`Prøver til ${item.name}`}
              value={item.plannedQuantity}
              min={0}
              disabled={!canEdit || isMutating}
              onChange={onChange}
            />
            <Mtds.Grid data-gap={2} className='grid-cols-2'>
              <Mtds.Button
                data-variant='secondary'
                onClick={() => onChange(0)}
                disabled={!canEdit || isMutating || item.plannedQuantity === 0}
              >
                Fjern alle
              </Mtds.Button>
              <Mtds.Button
                data-variant='secondary'
                onClick={() => onChange(item.plannedQuantity + remainder)}
                disabled={!canEdit || isMutating || remainder <= 0}
              >
                Fyll resten
              </Mtds.Button>
            </Mtds.Grid>
          </Mtds.Grid>
        )}
        <DelegationCardProgress
          samplesTaken={item.samplesTaken}
          quantity={item.plannedQuantity}
        />
      </Mtds.Grid>
    </Mtds.Card>
  )
}
